export default __webpack_public_path__ + "static/media/MiturLogoSecondary.e867f067.png";